var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"600px","fullscreen":_vm.isMobile},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('receipt-dialog-content',{attrs:{"receipt":_vm.receipt,"is-loading":_vm.isLoading,"show":_vm.show,"open-tab":_vm.openTab},on:{"close":function($event){_vm.show = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }